<template>
    <span class="latest-badge">{{ text }}</span>
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  text: {
    type: String,
    default: 'Latest'
  }
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.latest-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 0.34rem;
    padding: 0 0.08rem;
    border-radius: 0.04rem;
    font-size: 0.22rem;
    font-weight: 500;
    line-height: 0.34rem;
    color: rgba(0, 168, 67, 1);
    background: rgba(0, 168, 67, 0.2);
}
</style>
